import React, { useState } from "react";

interface Props {
    formData: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const BasicDetails: React.FC<Props> = ({ formData, onChange }) => {

    const [cnfrmPassword, setCnfrmPassword] = useState("");
    const [pwdError, setPwdError] = useState("");

    // Function to validate password and confirm password match
    const validatePasswords = (password: string, confirmPwd: string) => {
        if (confirmPwd && password !== confirmPwd) {
            setPwdError("Passwords do not match");
        } else {
            setPwdError("");
        }
    };

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label">First Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="firstName"
                                        required
                                        value={formData.firstName}
                                        onChange={onChange}
                                        placeholder="Enter First Name" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Last Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="lastName"
                                        required
                                        value={formData.lastName}
                                        onChange={onChange}
                                        placeholder="Enter Last Name" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="email"
                                        placeholder="Enter Email Address"
                                        required
                                        value={formData.email}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">User Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="userName"
                                        required
                                        value={formData.userName}
                                        onChange={onChange}
                                        placeholder="Enter User Name" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Permanent Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="permanentAddress"
                                        required
                                        value={formData.permanentAddress}
                                        onChange={onChange}
                                        placeholder="Enter Permanent Address" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Phone</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={10}
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="phone"
                                        placeholder="Enter Phone"
                                        required
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        value={formData.phone}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Date Of Birth</label>
                                    <input
                                        name="dateOfBirth"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        type="date"
                                        required
                                        value={formData.dateOfBirth}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="password"
                                        placeholder="Enter Password"
                                        required
                                        value={formData.password}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Confirm Password</label>
                                    <input
                                        type="password"
                                        className={`form-control ${pwdError ? "is-invalid" : ""}`}
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="confpassword"
                                        value={formData.confpassword}
                                        // onChange={(e) => { onchange; validatePasswords(formData.password, e.target.value) }}
                                        onChange={(e) => {
                                            onChange(e);
                                            validatePasswords(formData.password, e.target.value);
                                        }}
                                        placeholder="Confirm Password"
                                    />
                                    {pwdError && (
                                        <div className="invalid-feedback">{pwdError}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BasicDetails;